export const AUTH_API_BASE_URI = process.env.REACT_APP_DEVISE_API_URL || 'http://example.com/auth/'
export const API_BASE_URI = process.env.REACT_APP_API_URL || 'http://example.com/v1/'
export const API_KEY = process.env.REACT_APP_ACCESS_TOKEN
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
export const COST_ESTIMATE_API_BASE_URI = process.env.REACT_APP_CE_URL || 'http://example.com/beta/'
export const SIGN_IN_USERNAME = process.env.REACT_APP_SIGN_IN_USERNAME || ''
export const SIGN_IN_PASSWORD = process.env.REACT_APP_SIGN_IN_PASSWORD || ''
export const SIGN_IN_USER_DATA = process.env.REACT_APP_SIGN_IN_USER_DATA || ''
export const SIGN_IN_USER_AUTH_TOKEN = process.env.REACT_APP_SIGN_IN_USER_AUTH_TOKEN || ''
